import Seccion1 from '../productos/componentes/Seccion1';
import Seccion2 from '../productos/componentes/Seccion2';
import Seccion3 from '../productos/componentes/Seccion3';
import Seccion4 from '../productos/componentes/Seccion4';
import Seccion5 from '../productos/componentes/Seccion5';
import Seccion6 from '../productos/componentes/Seccion6';
import Seccion7 from '../productos/componentes/Seccion7';
import Seccion8 from '../productos/componentes/Seccion8';
import Seccion9 from '../productos/componentes/Seccion9';
import Seccion10 from '../productos/componentes/Seccion10';
import Seccion11 from '../productos/componentes/Seccion11';
import Seccion12 from '../productos/componentes/Seccion12';
import Seccion13 from '../productos/componentes/Seccion13';
import Seccion14 from '../productos/componentes/Seccion14';
import Seccion15 from '../productos/componentes/Seccion15';
import Seccion16 from '../productos/componentes/Seccion16';

export const secciones = [
  {
    titulo: '1',
    texto: 'IDENTIFICACIÓN DEL PRODUCTO',
    componente: Seccion1,
    url: {
      get: '/fds/producto/:id_empresa/:id_fds_producto',
      post: '/fds/producto',
      put: '/fds/producto'
    },
    tipos_documento: [ 'fds', 'te' ],
  },
  {
    titulo: '2',
    texto: 'IDENTIFICACIÓN DE PELIGROS',
    componente: Seccion2,
    url: {
      get: '/fds/producto/peligros/:id_empresa/:id_fds_producto',
      post: '/fds/producto/peligros',
      put: '/fds/producto/peligros'
    },
    tipos_documento: [ 'fds', 'te' ],
  },
  {
    titulo: '3',
    texto: 'INFORMACIÓN SOBRE COMPONENTES',
    componente: Seccion3,
    url: {
      get: '/fds/producto/componentes/:id_empresa/:id_fds_producto',
      post: '/fds/producto/componentes',
      put: '/fds/producto/componentes/:id',
    },
    tipos_documento: [ 'fds', 'te' ],
  },
  {
    titulo: '4',
    texto: 'MEDIDAS DE PRIMEROS AUXILIOS',
    componente: Seccion4,
    url: {
      get: '/fds/producto/primeros_auxilios/:id_empresa/:id_fds_producto',
      post: '/fds/producto/primeros_auxilios',
      put: '/fds/producto/primeros_auxilios/:id'
    },
    tipos_documento: [ 'fds', 'te' ],
  },
  {
    titulo: '5',
    texto: 'MEDIDAS DE LUCHA CONTRA INCENDIO',
    componente: Seccion5,
    url: {
      get: '/fds/producto/lucha_incendio/:id_empresa/:id_fds_producto',
      post: '/fds/producto/lucha_incendio',
      put: '/fds/producto/lucha_incendio/:id'
    },
    tipos_documento: [ 'fds', 'te' ],
  },
  {
    titulo: '6',
    texto: `MEDIDAS QUE DEBEN TOMARSE EN CASO DE VERTIDO ACCIDENTAL`,
    componente: Seccion6,
    url: {
      get: '/fds/producto/vertido_accidental/:id_empresa/:id_fds_producto',
      post: '/fds/producto/vertido_accidental',
      put: '/fds/producto/vertido_accidental/:id'
    },
    tipos_documento: [ 'fds', 'te' ],
  },
  {
    titulo: '7',
    texto: 'MANEJO Y ALMACENAMIENTO',
    componente: Seccion7,
    url: {
      get: '/fds/producto/manejo_almacenamiento/:id_empresa/:id_fds_producto',
      post: '/fds/producto/manejo_almacenamiento',
      put: '/fds/producto/manejo_almacenamiento/:id'
    },
    tipos_documento: [ 'fds' ],
  },
  {
    titulo: '8',
    texto: 'CONTROLES DE EXPOSICIÓN / PROTECCIÓN PERSONAL',
    componente: Seccion8,
    url: {
      get: '/fds/producto/controles_exposicion/:id_empresa/:id_fds_producto',
      post: '/fds/producto/controles_exposicion',
      put: '/fds/producto/controles_exposicion/:id'
    },
    tipos_documento: [ 'fds', 'te' ],
  },
  {
    titulo: '9',
    texto: 'PROPIEDADES FÍSICAS Y QUÍMICAS',
    componente: Seccion9,
    url: {
      get: '/fds/producto/propiedades/:id_empresa/:id_fds_producto',
      post: '/fds/producto/propiedades',
      put: '/fds/producto/propiedades/:id'
    },
    tipos_documento: [ 'fds' ],
  },
  {
    titulo: '10',
    texto: 'REACTIVIDAD Y ESTABILIDAD',
    componente: Seccion10,
    url: {
      get: '/fds/producto/reactividad_estabilidad/:id_empresa/:id_fds_producto',
      post: '/fds/producto/reactividad_estabilidad',
      put: '/fds/producto/reactividad_estabilidad/:id'
    },
    tipos_documento: [ 'fds', 'te' ],
  },
  {
    titulo: '11',
    texto: 'INFORMACIÓN TOXICOLÓGICA',
    componente: Seccion11,
    url: {
      get: '/fds/producto/informacion_toxicologica/:id_empresa/:id_fds_producto',
      post: '/fds/producto/informacion_toxicologica',
      put: '/fds/producto/informacion_toxicologica/:id'
    },
    tipos_documento: [ 'fds' ],
  },
  {
    titulo: '12',
    texto: 'INFORMACIÓN ECOTOXICOLÓGICA',
    componente: Seccion12,
    url: {
      get: '/fds/producto/informacion_ecotoxicologica/:id_empresa/:id_fds_producto',
      post: '/fds/producto/informacion_ecotoxicologica',
      put: '/fds/producto/informacion_ecotoxicologica/:id'
    },
    tipos_documento: [ 'fds' ],
  },
  {
    titulo: '13',
    texto: 'INFORMACIÓN RELATIVA A LA ELIMINACIÓN DE LOS PRODUCTOS',
    componente: Seccion13,
    url: {
      get: '/fds/producto/informacion_eliminacion/:id_empresa/:id_fds_producto',
      post: '/fds/producto/informacion_eliminacion',
      put: '/fds/producto/informacion_eliminacion/:id'
    },
    tipos_documento: [ 'fds' ],
  },
  {
    titulo: '14',
    texto: 'INFORMACIÓN RELATIVA AL TRANSPORTE',
    componente: Seccion14,
    url: {
      get: '/fds/in_development/:id_empresa/:id_fds_producto',
    },
    tipos_documento: [ 'fds', 'te' ],
  },
  {
    titulo: '15',
    texto: 'INFORMACIÓN SOBRE LA REGLAMENTACIÓN',
    componente: Seccion15,
    url: {
      get: '/fds/producto/informacion_reglamentacion/:id_empresa/:id_fds_producto',
      post: '/fds/producto/informacion_reglamentacion',
      put: '/fds/producto/informacion_reglamentacion/:id'
    },
    tipos_documento: [ 'fds' ],
  },
  {
    titulo: '16',
    texto: 'OTRAS INFORMACIONES',
    componente: Seccion16,
    url: {
      get: '/fds/producto/otras_informaciones/:id_empresa/:id_fds_producto',
      post: '/fds/producto/otras_informaciones',
      put: '/fds/producto/otras_informaciones/:id'
    },
    tipos_documento: [ 'fds' ],
  },
];
